import { useMemo } from 'react';

import { PER_PAGE } from '../../constants';

type bookmark = { id: string; group: string };
type groupedBookmarkList = Map<bookmark['group'], bookmark[]>;

export function useChunkedBookmarks(bookmarks: bookmark[]) {
  const chunkedBookmarks = useMemo(() => {
    let currentItemCount = 0;
    let currentPageCount = 0;
    const chunks: bookmark[][] = [];
    const groupedBookmarks: groupedBookmarkList = new Map();

    [...bookmarks]
      .reverse()
      .forEach((item) =>
        groupedBookmarks.set(item.group, [...(groupedBookmarks.get(item.group) || []), item]),
      );

    groupedBookmarks.forEach((group) => {
      if (currentItemCount + group.length > PER_PAGE) {
        currentPageCount++;
        currentItemCount = 0;
      }
      currentItemCount += group.length;
      chunks[currentPageCount] = [...(chunks[currentPageCount] || []), ...group];
    });

    return chunks;
  }, [bookmarks]);

  return {
    chunkedBookmarks,
    maxPages: chunkedBookmarks.length - 1,
  } as const;
}
